import axios from "../utils/axios";

export default class service {
  static baseURL = "user";

  static login(data) {
    return axios.post(this.baseURL + "/login", data);
  }
  static logoutAllDevices() {
    return axios.post(this.baseURL + "/logout-all-devices");
  }
  static validateToken(data) {
    return axios.post("../validate-token", data);
  }
  static profile(data) {
    return axios.get(this.baseURL + "/profile", { params: data });
  }


 static dashboardStats(data) {
    return axios.get(this.baseURL + "/dashboard-stats", { params: data });
  }

  static saveProfile(data) {
    return axios.post(this.baseURL + "/save-profile", data);
  }
  static updatePassword(data) {
    return axios.post(this.baseURL + "/update-password", data);
  }

  static list(data) {
    return axios.get(this.baseURL + "/list", { params: data });
  }
  static save(data) {
    return axios.post(this.baseURL + "/save", data);
  }
  static delete(id) {
    return axios.post(this.baseURL + "/delete", { ids: id });
  }

  /// users api
  static listUser(data) {
    return axios.get(this.baseURL + "/list-user", { params: data });
  }
  static saveUser(data) {
    return axios.post(this.baseURL + "/save-user", data);
  }
  static deleteUser(id) {
    return axios.post(this.baseURL + "/delete-user", { ids: id });
  }
  static changeAvatar(data) {
    return axios.post(this.baseURL + "/change-avatar", data);
  }

  static listSubAdmins(data) {
    return axios.get(this.baseURL + "/list-subAdmins", { params: data });
  }
  static saveSubAdmins(data) {
    return axios.post(this.baseURL + "/save-subAdmins", data);
  }
  static deleteSubAdmins(id) {
    return axios.post(this.baseURL + "/delete-subAdmins", { ids: id });
  }

  static listRecentUsers(data) {
    return axios.get(this.baseURL + "/recent-users", { params: data });
  }
}
